import React from 'react';
import classnames from 'classnames';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import { withTranslation, WithTranslation } from 'react-i18next';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';
import { StatsRoutesMap } from './constants';
import { ModuleType } from '../../../../../types/modules';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { BiLink, BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import _get from 'lodash/get';

import s from './SideNavBar.scss';

export interface SideNavBarProps {
  routes: {
    key: string;
    hash: string;
  }[];
  activeHash?: string;
  onActiveHashChange: (activeHash: string) => void;
  stats: object;
  className?: string;
  isOwner?: boolean;
}

function workaroundChromeHashFragmentBug(clickEvent, idScrolledTo) {
  // Chrome hash fragment scrolling can overshoot in some cases, see https://phrac.deviantart.net/T38631
  // TODO: remove if/when this is fixed at some point after chrome 75
  // also note: this potentially surpresses the click event in chrome., so if you're adding
  // a bi click event to this nav menu, we need to remove this workaround

  // agent sniffing isn't great, but this is a chrome specific error
  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  if (!isChrome) {
    return;
  }
  const sectionScrolledTo = document.getElementById(idScrolledTo);
  if (!sectionScrolledTo) {
    return;
  }

  clickEvent.preventDefault();
  sectionScrolledTo.scrollIntoView();
}

class SideNavBar extends React.Component<SideNavBarProps & WithTranslation> {
  render() {
    const marginTop = 114;
    const {
      routes,
      className,
      activeHash,
      onActiveHashChange,
      stats,
      isOwner,
      t,
    } = this.props;

    return (
      <ErrorBoundary hideOnFail>
        <div className={s['root']}>
          <Sticky
            zIndex={parseInt(s['z-index'])}
            marginTop={marginTop}
            className={s['sticky-align-left']}
            bottomStop={(width: number) =>
              parseInt(width > 1366 ? s.footerHeight1920 : s.footerHeight1366)
            }
          >
            {isStuck => (
              <nav
                className={classnames(
                  s['nav-sidebar'],
                  isStuck && s['sticky'],
                  className
                )}
              >
                {routes.map(route => {
                  const statName = StatsRoutesMap[route.hash];
                  const statValue = stats[statName];
                  const hideItem = !isOwner && statValue === 0;
                  const formattedCount =
                    route.hash !== ModuleType.MY_COMMENTS && // we don't show count for My comment item
                    statValue &&
                    shortenNumber(statValue);

                  return (
                    !hideItem && (
                      <BiLink
                        biData={{
                          evid: BiEventType.PROFILE_ABOUT_SLIDEBAR,
                          menu_item_name: route.hash,
                        }}
                        key={route.hash}
                        href={`#${route.hash}`}
                        className={classnames(
                          s['nav-link-item'],
                          activeHash && activeHash === route.hash && s['active']
                        )}
                        onClick={e => {
                          workaroundChromeHashFragmentBug(e, route.hash);
                          onActiveHashChange(route.hash);
                        }}
                      >
                        {t!(route.key)}
                        <span className={s['count']}>{formattedCount}</span>
                      </BiLink>
                    )
                  );
                })}
              </nav>
            )}
          </Sticky>
        </div>
      </ErrorBoundary>
    );
  }
}

export default withTranslation()(SideNavBar);
